import { ColorSchemeScript, MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { Notifications } from "@mantine/notifications";

import { DATE_SETTINGS, NOTIFICATION_SETTINGS, THEME } from "@/lib/Mantine";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";

export function MantineProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="light" />
      <MantineProvider theme={THEME} defaultColorScheme="light" deduplicateInlineStyles>
        <DatesProvider settings={DATE_SETTINGS}>
          {children}
          <Notifications {...NOTIFICATION_SETTINGS} />
        </DatesProvider>
      </MantineProvider>
    </>
  );
}
